WiseMetering.Views.WeatherAPIIntegrationsTable = WiseMetering.Views.TableIndex.extend({
    icon: 'integrations',
    name: () => 'weather_api',

    createTable: function() {
        this.collection = this.model.integrations();

        this.table = new WiseMetering.Views.Table({
            id: 'integrations',
            collection: this.collection,
            disableSelect: true,
            modelSerializer: model => {
                let
                    color = 'orange',
                    state = model.get('state');

                if (state === 'active') {
                    color = 'green';
                }

                return {
                    siteName: model.site().get('name'),
                    id: model.id,
                    name: model.get('name'),
                    lastRunAt: model.get('last_run_at') ? WiseMetering.utils.formatDate(model.get('last_run_at')) : '-',
                    updatedAt: WiseMetering.utils.formatDate(model.get('updated_at')),
                    state: { color, state }
                };
            },
            columns: {
                state: {
                    mRender: ({ color, state }) => JST['templates/ui/components/circle']({
                        color: WiseMetering.SemaphorColors[color],
                        title: state.capitalize()
                    }),
                    sWidth: '20px'
                },
                name: i18next.t('common.name'),
                siteName: i18next.t('glossary.site'),
                lastRunAt: i18next.t('integrations.last_run_at'),
                updatedAt: i18next.t('glossary.last_change')
            },
            toolbar_actions: {
                // new: {
                //     label: i18next.t('ui.actions.new'),
                //     view_call: () => new WiseMetering.Views.NewWeatherAPIIntegration({
                //         collection: WiseMetering.integrations,
                //         license: this.model,
                //         model: new WiseMetering.Model.Integration({ license_id: this.model.id })
                //     })
                // },
                show: {
                    label: i18next.t('ui.actions.show'),
                    view_call: model => new WiseMetering.Views.ShowWeatherAPIIntegration({ model })
                }
                // disable: {
                //     icon: 'disable',
                //     label: i18next.t('ui.actions.disable'),
                //     view_call: model => new WiseMetering.Views.DisableIntegration({ model })
                // },
                // delete: {
                //     permission: 'superuser',
                //     view_call: model => new WiseMetering.Views.Modal.DestroyExtraConfirmation({
                //         model,
                //         title: () => i18next.t('modal.title.integrations.destroy')
                //     })
                // }
            }
        });

        $(this.body.el).html(this.table.el);
    },

    onClose: function() {
        this.stopListening(WiseMetering.integrations);

        if (this.table && this.table.remove && typeof (this.table.remove) === 'function') {
            this.table.remove();
        }
    },

    onShow: function() {
        this.listenTo(WiseMetering.integrations, 'remove add change', this.createTable.bind(this));

        this.createTable();
    }
});
